export default __webpack_public_path__ + "static/media/doc.e1fd96a1.png";